import React from "react";
import { Box, Typography, useMediaQuery, useTheme } from "@mui/material";
import { RaceCard } from "./race-card";
import { fontSizes } from "../../../theme/font-sizes";
import { darkColors } from "../../../theme/colors";
import { assetIcons } from "../../../constants/assets";
import { useNavigate } from "react-router-dom";
import routes from "../../../constants/routes";
import InlineSvg from "../inline-svg";

export const LiveRacesSection = ({ races, onClick, showSeeMore = true }) => {
  const navigate = useNavigate();
  const theme = useTheme();
  const isMediumScreen = useMediaQuery(theme.breakpoints.down("lg"));
  const navigateLiveRaces = () => {
    navigate(routes.live_games);
  };

  return (
    <Box sx={{ mb: isMediumScreen ? 20 : 10 }}>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mb: 0,
        }}
      >
        <Typography
          fontWeight={700}
          fontSize={fontSizes.heading2}
          color="white"
        >
          Live Races
        </Typography>
        {showSeeMore && (
          <Typography
            fontWeight={700}
            fontSize={fontSizes.heading3}
            color={darkColors.seeMore}
            sx={{
              cursor: "pointer",
            }}
            onClick={navigateLiveRaces}
          >
            See More <InlineSvg sx={{ ml: 1 }} url={assetIcons.seeMoreIcon} />
          </Typography>
        )}
      </Box>
      <Box
        sx={{
          display: "flex",
          flexWrap: "wrap",
          gap: 2,
          mt: 3,
        }}
      >
        {races.length > 0 ? (
          races.map((race, index) => (
            <RaceCard
              key={race.id} // Use a unique key, such as an ID from the data if available
              title={race.title}
              time={race.time}
              runners={race.runners}
              backgroundImage={race.backgroundImage}
              onClick={() => onClick(race.id)}
            />
          ))
        ) : (
          <Typography color="white">
            No live races right now, please try later
          </Typography>
        )}
      </Box>
    </Box>
  );
};
